export default "__VITE_ASSET__DPT1__B4__"